"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../../..");
var components_1 = require("../../../components");
var button_1 = require("../../../components/button/button");
var MeetingsBoldReportPage = /** @class */ (function (_super) {
    __extends(MeetingsBoldReportPage, _super);
    function MeetingsBoldReportPage(api, navigator, currentUserManager, reportOptions) {
        var _this = _super.call(this, __1.PageTypes.MeetingsBoldReportPage, 'Meetings Report') || this;
        _this.api = api;
        _this.navigator = navigator;
        _this.currentUserManager = currentUserManager;
        _this.reportOptions = reportOptions;
        _this.observationProvider = new __1.ObservationProvider();
        _this.backButton = new button_1.default({
            leftIcon: components_1.Icons.ChevronLeft,
            onClick: _this.navigator.goBack,
            text: 'Back',
            isVisible: currentUserManager.clientChecker.isMobileApp()
        });
        _this.observationProvider.notifyObservers(__1.MeetingsBoldReportPageActions.LoadedBoldReportsViewer);
        return _this;
    }
    Object.defineProperty(MeetingsBoldReportPage.prototype, "isLoading", {
        get: function () {
            return this._isLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingsBoldReportPage.prototype, "currentUsersName", {
        get: function () {
            return this.currentUserManager.userFullName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingsBoldReportPage.prototype, "reportData", {
        get: function () {
            return this._reportData;
        },
        enumerable: false,
        configurable: true
    });
    return MeetingsBoldReportPage;
}(__1.BasePage));
exports.default = MeetingsBoldReportPage;
